<script setup lang="ts">
import { useStore } from '@/store';
import CsvUpload from '@/components/CsvUpload.vue';

const store = useStore();

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString();
};

const viewSwish = (id: string) => {
  console.log('View Swish:', id);
  // Implement view functionality
};

const editSwish = (id: string) => {
  console.log('Edit Swish:', id);
  // Implement edit functionality
};

const removeSwish = (id: string) => {
  console.log('Remove Swish:', id);
  // Implement remove functionality
};
</script>

<template>
  <div class="container mx-auto p-4">
    <h1 class="text-3xl font-bold mb-4">Admin Dashboard</h1>
    <div class="bg-gray-800 rounded-lg shadow-lg p-6">
      <h2 class="text-2xl font-semibold mb-4">Swishes</h2>
      <table class="w-full text-left">
        <thead>
          <tr>
            <th class="pb-3 text-sm font-medium text-gray-400">#</th>
            <th class="pb-3 text-sm font-medium text-gray-400">Name</th>
            <!-- <th class="pb-3 text-sm font-medium text-gray-400">Is Public</th> -->
            <th class="pb-3 text-sm font-medium text-gray-400">Access List</th>
            <th class="pb-3 text-sm font-medium text-gray-400">Last Modified</th>
            <th class="pb-3 text-sm font-medium text-gray-400">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(swish, index) in store.swishes" :key="swish.id" class="border-t border-gray-700">
            <td class="py-3 text-sm">{{ index + 1 }}</td>
            <td class="py-3 text-sm">{{ swish.name }}</td>
            <!-- <td class="py-3 text-sm">{{ swish.public ? 'Yes' : 'No' }}</td> -->
            <td class="py-3 text-sm"><div v-if="swish.public">Public</div><div v-else>{{ swish.userIds.join(', ') }}</div></td>
            <td class="py-3 text-sm">{{ formatDate(swish.lastModified) }}</td>
            <td class="py-3 text-sm">
              <button @click="viewSwish(swish.id)" class="text-blue-500 hover:text-blue-700 mr-2">View</button>
              <button @click="editSwish(swish.id)" class="text-green-500 hover:text-green-700 mr-2">Edit</button>
              <button @click="removeSwish(swish.id)" class="text-red-500 hover:text-red-700">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <CsvUpload />
  </div>
</template>
